import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import debounce from 'lodash/debounce'

export function trackQuestionModified(attribute: string) {
  return (newInputValue: string | string[]) =>
    trackEvent(TrackingEvents.TRIAL_APPLICATION_QUESTION_MODIFIED, {
      questionnaireAttribute: attribute,
      questionnaireInputValue: newInputValue,
      source: TrackingSources.APPLY_FLOW_V2,
    })
}

export const debounceTrackQuestionModified = (attribute: string) =>
  debounce(trackQuestionModified(attribute), 250)
